






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'
import {InputAlertaCargaSchema} from '@/schema/resource/AlertaCarga/InputAlertaCargaSchema'

@Component
export default class PersistAlertaCargaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAlertaCargaSchema()
  alertaCarga = new AlertaCarga()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionAlerta.listAlerta()
    this.schema.collectionCarga.listCarga()
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.alertaCarga.getAlertaCarga(id)
    }

    $.await.done('getAlertaCarga')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.alertaCarga.persistAlertaCarga()
    await Helper.successAndPush('system.success.persist', '/alerta-carga/list')
  }
}
